import {OrderCreatedEvent, ProductAddedToBasketEvent, ProductRemovedFromBasketEvent} from '@/src/core/domain/events'
import {injectable} from 'inversify'
import {OrderDetails} from '@/src/entities/order/types'
import values from 'lodash/values'
import {PulseEventMap} from '@/src/core/domain/services/analytic/types'
import type {PulseAnalyticsServiceInterface} from '@/src/ports/services/analytic-service'

@injectable()
export class PulseAnalytics {
  constructor(private analyticService: PulseAnalyticsServiceInterface) {}

  track(event: string, payload: unknown) {
    this.analyticService.track(event, payload)
  }

  trackAddToCart(event: ProductAddedToBasketEvent) {
    this.analyticService.track(PulseEventMap.AddToCart, {
      productId: event.payload!.productId,
      productName: event.payload!.productName,
      imageUrl: event.payload!.imageUrl,
      productUrl: event.payload!.productUrl,
      price: event.payload!.price,
      currency: 'RUB',
    })
  }

  trackRemoveToCart(event: ProductRemovedFromBasketEvent) {
    this.analyticService.track(PulseEventMap.RemoveFromCart, {
      productName: event.payload!.productName,
    })
  }


  trackClearCart() {
    this.analyticService.track(PulseEventMap.ClearCart, {})
  }

  trackOrderPlaced(event: OrderCreatedEvent) {
    this.analyticService.track(PulseEventMap.OrderPlaced, {
      orderId: event.payload?.orderId,
      amount: parseFloat(String(event.payload?.totalAmount)),
      currency: 'RUB',
    })
  }

  trackOrderRedirectToBank({orderId, url}: {orderId: Id; url: string}) {
    this.analyticService.track(PulseEventMap.RedirectedToBank, {
      orderId: orderId,
      url: url,
    })
  }

  trackOrderPurshase(order: OrderDetails) {
    this.analyticService.track(PulseEventMap.OrderPurshase, {
      orderId: order.number,
      amount: order.total,
      currency: 'RUB',
      items: values(order.lines).map(orderLine => ({
        total: parseFloat(String(orderLine.total)),
        qty: parseFloat(String(orderLine.quantity)),
        name: orderLine.name,
      })),
    })
  }

  identify(payload: unknown) {
    this.analyticService.identify(payload)
  }
}
